// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeJKYC {
  display: flex;
  align-items: center;
  border-radius: var(--radius-pill);
  border: none;
  outline: none;
  cursor: pointer;
  user-select: none;
  transition:
    background 0.2s,
    color 0.2s,
    border 0.2s;
  gap: var(--spacing-0-5);
  background: var(--surface-neutral-soft);
  padding-left: var(--spacing-1);
  padding-right: var(--spacing-1);
  padding-top: var(--spacing-0-5);
  padding-bottom: var(--spacing-0-5);
  height: 24px;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.mXEsQs {
  height: 24px;
  font-size: var(--font-size-sm);
}

.qpIfPM {
  height: 32px;
  font-size: var(--font-size-md);
}

.IWHBDf {
  font-weight: var(--font-weight-semibold);
  background: var(--surface-primary-subtle);
  color: var(--text-primary-medium);
  border: 1px solid var(--surface-primary-medium);
}

.R4RWXv {
  background: var(--surface-neutral-pale);
  color: var(--text-neutral-silver);
  cursor: not-allowed;
  opacity: 0.6;
}

.DeJKYC:not(.R4RWXv):not(.IWHBDf):hover {
  background: var(--surface-neutral-subtle);
  color: var(--text-primary-medium);
}

.Br4RJ1 {
  display: flex;
  align-items: center;
}

.ewTJGv {
  display: inline-block;
  width: 14px;
  height: 14px;
  filter: brightness(0) saturate(100%) invert(12%) sepia(4%) saturate(230%) hue-rotate(330deg) brightness(76%)
    contrast(95%);
  transition: filter 0.2s ease;
}

.DeJKYC.mXEsQs .ewTJGv {
  width: 12px;
  height: 12px;
}

.DeJKYC.qpIfPM .ewTJGv {
  width: 14px;
  height: 14px;
}

.DeJKYC:not(.R4RWXv):not(.IWHBDf):hover .ewTJGv {
  filter: brightness(0) saturate(100%) invert(39%) sepia(92%) saturate(6545%) hue-rotate(9deg) brightness(97%)
    contrast(104%);
}

.DeJKYC.IWHBDf .ewTJGv {
  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)
    contrast(104%);
}

.DeJKYC.R4RWXv .ewTJGv {
  filter: brightness(0) saturate(100%) invert(62%) sepia(0%) saturate(0%) hue-rotate(192deg) brightness(120%)
    contrast(90%);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Chip/Chip.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB;;;eAGa;EACb,uBAAuB;EACvB,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,kCAAkC;EAClC,YAAY;EACZ,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ;iBACe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;kBACgB;AAClB;;AAEA;EACE;kBACgB;AAClB;;AAEA;EACE;iBACe;AACjB","sourcesContent":[".chip {\n  display: flex;\n  align-items: center;\n  border-radius: var(--radius-pill);\n  border: none;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n  transition:\n    background 0.2s,\n    color 0.2s,\n    border 0.2s;\n  gap: var(--spacing-0-5);\n  background: var(--surface-neutral-soft);\n  padding-left: var(--spacing-1);\n  padding-right: var(--spacing-1);\n  padding-top: var(--spacing-0-5);\n  padding-bottom: var(--spacing-0-5);\n  height: 24px;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.small {\n  height: 24px;\n  font-size: var(--font-size-sm);\n}\n\n.medium {\n  height: 32px;\n  font-size: var(--font-size-md);\n}\n\n.selected {\n  font-weight: var(--font-weight-semibold);\n  background: var(--surface-primary-subtle);\n  color: var(--text-primary-medium);\n  border: 1px solid var(--surface-primary-medium);\n}\n\n.disabled {\n  background: var(--surface-neutral-pale);\n  color: var(--text-neutral-silver);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.chip:not(.disabled):not(.selected):hover {\n  background: var(--surface-neutral-subtle);\n  color: var(--text-primary-medium);\n}\n\n.text {\n  display: flex;\n  align-items: center;\n}\n\n.chipIcon {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  filter: brightness(0) saturate(100%) invert(12%) sepia(4%) saturate(230%) hue-rotate(330deg) brightness(76%)\n    contrast(95%);\n  transition: filter 0.2s ease;\n}\n\n.chip.small .chipIcon {\n  width: 12px;\n  height: 12px;\n}\n\n.chip.medium .chipIcon {\n  width: 14px;\n  height: 14px;\n}\n\n.chip:not(.disabled):not(.selected):hover .chipIcon {\n  filter: brightness(0) saturate(100%) invert(39%) sepia(92%) saturate(6545%) hue-rotate(9deg) brightness(97%)\n    contrast(104%);\n}\n\n.chip.selected .chipIcon {\n  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)\n    contrast(104%);\n}\n\n.chip.disabled .chipIcon {\n  filter: brightness(0) saturate(100%) invert(62%) sepia(0%) saturate(0%) hue-rotate(192deg) brightness(120%)\n    contrast(90%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `DeJKYC`,
	"small": `mXEsQs`,
	"medium": `qpIfPM`,
	"selected": `IWHBDf`,
	"disabled": `R4RWXv`,
	"text": `Br4RJ1`,
	"chipIcon": `ewTJGv`
};
module.exports = ___CSS_LOADER_EXPORT___;
